import { gql } from '@apollo/client';

export const GET_MASTER_EVENTS = gql`
  query findMasterEventsQuery($input: FindMasterEventsQueryInput!) {
    result: findMasterEventsQuery(input: $input) {
      data {
        value {
          _id
          name
          createdBy
          startAt
          country {
            _id
          }
          endAt
          isArchived
          admins {
            _id
          }
          type {
            _id
          }
          coverImage {
            urlRegular
          }
        }
      }
      pagination {
        currentPage
        itemsPerPage
        totalPages
        totalItems
      }
    }
  }
`;

export const GET_MASTER_EVENT = gql`
  query masterEvent($_id: String!) {
    masterEvent(_id: $_id) {
      _id
      name
      startAt
      endAt
      createdAt
      createdBy
      isArchived
      campaignId
      country {
        _id
        translations {
          _id
          name
        }
      }
      admins {
        _id
        displayName
      }
      devices
      language {
        _id
        name
      }
      userLanguage {
        _id
        name
      }
      card
      secondCard
      type {
        _id
        name
      }
      coverImage {
        unsplashId
        unsplashLink
        unsplashUserName
        unsplashUserUrl
        urlFull
        urlRegular
      }
      widgets {
        _id
        content {
          options
          type
        }
        layouts {
          desktop {
            height
            positionX
            positionY
            preCollapseHeight
            width
          }
          mobile {
            height
            positionX
            positionY
            preCollapseHeight
            width
          }
        }
        movable
        resizable
        title
      }
    }
  }
`;

export const GET_MASTER_EVENT_GUESTS_STATS = gql`
  query masterEventGuestsStats($_id: String!) {
    masterEvent(_id: $_id) {
      _id
      guests {
        total
        totalRsvped
        totalCheckedIn
        totalCheckedOut
      }
    }
  }
`;

export const GET_MASTER_EVENT_TYPES = gql`
  query masterDataEventTypes {
    result: masterDataEventTypes {
      _id
      name
    }
  }
`;

export const CREATE_OR_UPDATE_MASTER_EVENT = gql`
  mutation upsertOneMasterEvent($query: MasterEventQueryInput!, $data: MasterEventInsertInput!) {
    result: upsertOneMasterEvent(query: $query, data: $data) {
      value {
        _id
      }
    }
  }
`;

export const DELETE_MASTER_EVENT = gql`
  mutation deleteOneMasterEvent($query: MasterEventQueryInput!) {
    deleteOneMasterEvent(query: $query) {
      deletedCount
    }
  }
`;

export const UPDATE_MASTER_EVENT_WIDGETS = gql`
  mutation updateOneMasterEvent($query: MasterEventQueryInput!, $set: MasterEventUpdateInput!) {
    result: updateOneMasterEvent(query: $query, set: $set) {
      value {
        _id
      }
    }
  }
`;
